import { makeAutoObservable, runInAction } from 'mobx';

class ModalStore {
  modals = [];

  constructor() {
    makeAutoObservable(this);
  }

  openModal(name, props = {}, single = false) {
    runInAction(() => {
      this.modals = this.modals.filter((item) => !item.single);
      this.modals.push({ name, props, single });
    });
  }

  closeModal(name) {
    if (name) {
      this.modals = this.modals.filter((modal) => modal.name !== name);
    } else {
      this.modals.pop();
    }
  }

  closeAllModals() {
    this.modals = [];
  }

  get activeModal() {
    return this.modals.length ? this.modals[this.modals.length - 1] : null;
  }
}

export const modalStore = new ModalStore();
